import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelecrSeriesStore, SelectResultArray } from "../../../redux/2d-slice/seriesSlice2d";
import { SocketState } from "../../../context/SocketProvider";
import { SelectAdvanceDrawSelectTime } from "../../../redux/2d-slice/gameInfo2dSlice";
import { SET_MAIN_LOADER } from "../../../redux/loaderSlice";

import { SET_LOGIN_FORM_ERROR, SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';

function PlaceBat2d() {
  const dispatch = useDispatch();
  const { socket } = SocketState();
  const resultArray = useSelector(SelectResultArray);
  const AdvanceDrawSelectTime = useSelector(SelectAdvanceDrawSelectTime);
  const seriesStore = useSelector(SelecrSeriesStore);

  // ✅ useCallback to keep reference stable across renders
  const submitBat = useCallback(() => {
    // console.log("✅ submitBat triggered");

    dispatch(SET_MAIN_LOADER(true));

    let card_details = {};
    let totalAmount = 0;
    resultArray.forEach((resArray, resIndex) => {
      resArray.forEach((_, resultIndex) => {
        const seriesField = seriesStore[resIndex]?.seriesAllfield?.[resultIndex] || [];
        seriesField.forEach((inputField) => {
          const val = inputField?.getFinalValue?.() ?? 0;
          if (val > 0) {
            card_details[inputField.printNumber] = val * 2;
            totalAmount += val * 2;
          }
        });
      });
    });


    if (totalAmount < 10) {
      dispatch(
        SHOW_MAIN_ERROR_MODAL(
          "❌ Minimum Bet Amount Total 10 se Zyada Hona Chahiye"
        )
      );
      dispatch(SET_MAIN_LOADER(false));
      return;
    }

    const mobile_number = localStorage.getItem("mobile_number") ?? null;
    // console.log("📞 Sending with mobile number:", mobile_number);

    socket.emit("req", {
      en: "MINI_LOTTERY_PLACE_BET",
      data: {
        advance_bet: AdvanceDrawSelectTime.length > 0,
        advance_bet_times: AdvanceDrawSelectTime,
        card_details,
        mobile_number,
      },
    });

    localStorage.removeItem("mobile_number");
  }, [dispatch, resultArray, seriesStore, socket, AdvanceDrawSelectTime]);

  // ✅ Add stable event listeners
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F6") {
        event.preventDefault();
        submitBat();
      }
    };

    const handleWhatsappPlaceBet = () => {
      // console.log("📲 whatsappPlaceBet event received");
      submitBat();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);
    };
  }, [submitBat]);

  return (
    <div className="footer_btn report_btn" onClick={submitBat}>
      PRINT(F6)
    </div>
  );
}

export default PlaceBat2d;
